import { useEffect, useState } from "react";
import { Edit, Trash2, Star } from "lucide-react";
import { toast } from "sonner";
import { adminGetTestimonials, adminCreateTestimonial, adminUpdateTestimonial, adminDeleteTestimonial } from "./adminApi";
import { Text, Area, Toggle, Select, Modal } from "./ui";
import { Header } from "./AdminTours";

const blank = { name: "", country: "Malaysia", country_flag: "🇲🇾", review: "", rating: 5, photo: "", video_url: "", featured: false, order: 0 };
const FLAGS = { Malaysia: "🇲🇾", Indonesia: "🇮🇩", Singapore: "🇸🇬", Brunei: "🇧🇳", Thailand: "🇹🇭", India: "🇮🇳", Other: "🌏" };

export default function AdminTestimonials() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = () => adminGetTestimonials().then(setItems).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!editing.name) { toast.error("Name required"); return; }
    setSaving(true);
    try {
      const payload = { ...editing, rating: Number(editing.rating) || 5, order: Number(editing.order) || 0 };
      if (editing.id) await adminUpdateTestimonial(editing.id, payload); else await adminCreateTestimonial(payload);
      toast.success("Saved"); setEditing(null); load();
    } catch { toast.error("Save failed"); } finally { setSaving(false); }
  };
  const del = async (t) => { if (!window.confirm(`Delete review by ${t.name}?`)) return; await adminDeleteTestimonial(t.id); toast.success("Deleted"); load(); };
  const set = (k, v) => setEditing((e) => ({ ...e, [k]: v }));

  return (
    <div>
      <Header title="Testimonials" count={items.length} onNew={() => setEditing({ ...blank })} newLabel="Add Review" />
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {items.map((t) => (
          <div key={t.id} className="bg-white border border-[#d4af37]/25 p-5 flex gap-4">
            <span className="w-12 h-12 rounded-full bg-[#14523d] text-white grid place-items-center text-xl shrink-0">{t.country_flag || "🌏"}</span>
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between">
                <div className="font-medium text-[#3b1a1a]">{t.country_flag} {t.name}</div>
                <div className="flex gap-1">
                  <button onClick={() => setEditing({ ...blank, ...t })} data-testid={`edit-testi-${t.id}`} className="w-8 h-8 grid place-items-center text-[#14523d] hover:bg-[#14523d] hover:text-white"><Edit className="w-4 h-4" /></button>
                  <button onClick={() => del(t)} className="w-8 h-8 grid place-items-center text-[#7c1d1d] hover:bg-[#7c1d1d] hover:text-white"><Trash2 className="w-4 h-4" /></button>
                </div>
              </div>
              <div className="flex items-center gap-0.5 text-[#d4af37] mt-1">{Array.from({ length: t.rating }).map((_, i) => <Star key={i} className="w-3 h-3 fill-[#d4af37]" strokeWidth={0} />)}</div>
              <p className="text-sm text-[#5a4b4b] mt-2 clamp-3">{t.review}</p>
              {t.featured && <span className="inline-block mt-2 text-[10px] uppercase bg-[#d4af37]/20 text-[#7c1d1d] px-2 py-0.5">Featured</span>}
            </div>
          </div>
        ))}
      </div>

      <Modal open={!!editing} onClose={() => setEditing(null)} title={editing?.id ? "Edit Review" : "Add Review"}>
        {editing && (
          <div className="space-y-4">
            <Text label="Guest Name *" value={editing.name} onChange={(v) => set("name", v)} />
            <div className="grid grid-cols-2 gap-4">
              <Select label="Country" value={editing.country} onChange={(v) => { set("country", v); set("country_flag", FLAGS[v] || "🌏"); }} options={Object.keys(FLAGS)} />
              <Select label="Rating" value={String(editing.rating)} onChange={(v) => set("rating", v)} options={["5", "4", "3", "2", "1"]} />
            </div>
            <Area label="Review" value={editing.review} onChange={(v) => set("review", v)} rows={4} />
            <Text label="Video URL (optional)" value={editing.video_url} onChange={(v) => set("video_url", v)} placeholder="YouTube / Vimeo link" />
            <div className="flex items-center gap-6"><Toggle label="Featured on homepage" value={editing.featured} onChange={(v) => set("featured", v)} /><Text label="Order" type="number" value={editing.order} onChange={(v) => set("order", v)} /></div>
            <div className="flex gap-3"><button onClick={save} disabled={saving} data-testid="save-testi" className="bg-[#7c1d1d] text-white px-8 py-3 text-xs tracking-[0.2em] uppercase disabled:opacity-60">{saving ? "Saving…" : "Save"}</button><button onClick={() => setEditing(null)} className="border border-[#d4af37]/40 px-8 py-3 text-xs tracking-[0.2em] uppercase">Cancel</button></div>
          </div>
        )}
      </Modal>
    </div>
  );
}
